/**
 * Miniatures des photos du site : les cartes et vignettes affichent des images dans
 * 300 à 600 px de large alors que les fichiers d'origine font jusqu'à 2000 px.
 * `thumb()` renvoie la variante 640 px (dossier public/img/w640, ~3x plus légère).
 *
 * Les variantes sont générées une fois pour toutes avec Pillow :
 *   cd frontend/public/img && python3 -c "from PIL import Image; import glob,os
 *   [Image.open(f).convert('RGB').resize((640, round(Image.open(f).height*640/Image.open(f).width)))
 *     .save('w640/'+os.path.splitext(f)[0]+'.webp','WEBP',quality=80,method=6)
 *     for f in glob.glob('*.webp')+glob.glob('*.jpg')]"
 *
 * Si une miniature manque, l'attribut onError des composants recharge l'original.
 */
export function thumb(url) {
  if (!url || !url.startsWith("/img/") || url.includes("/w640/")) return url;
  const file = url.slice("/img/".length);
  if (file.includes("/")) return url;
  return `/img/w640/${file.replace(/\.(jpe?g|png|webp)$/i, ".webp")}`;
}

/**
 * Variante 1280 px (dossier public/img/w1280) pour les grands affichages : photo
 * héros, bandeau pédagogie, coupures de presse — là où 640 px serait flou.
 */
export function thumbWide(url) {
  if (!url || !url.startsWith("/img/") || /\/w(640|1280)\//.test(url)) return url;
  const file = url.slice("/img/".length);
  if (file.includes("/")) return url;
  return `/img/w1280/${file.replace(/\.(jpe?g|png|webp)$/i, ".webp")}`;
}

/**
 * Jeu de tailles pour les vignettes : le mobile télécharge la variante 320 px
 * (≈ 11 ko au lieu de 48 ko), le desktop la 640 px. À utiliser avec `sizes`.
 */
export function thumbSet(url) {
  if (!url || !url.startsWith("/img/") || /\/w(320|640|1280)\//.test(url)) return undefined;
  const file = url.slice("/img/".length);
  if (file.includes("/")) return undefined;
  const webp = file.replace(/\.(jpe?g|png|webp)$/i, ".webp");
  return `/img/w320/${webp} 320w, /img/w640/${webp} 640w`;
}

/** À passer en onError : revient à la photo d'origine si la miniature est absente. */export function fallbackToFull(original) {
  return (event) => {
    if (event.currentTarget.dataset.fallback) return;
    event.currentTarget.dataset.fallback = "1";
    event.currentTarget.src = original;
  };
}
